import { TextBlock } from '../client-data-types/blocks'

export interface CreateDiagExampleOptions {
    linkText?: string
}

export const createDiagExample = (
    url: string,
    description: string,
    options: CreateDiagExampleOptions = {},
): TextBlock => {
    const trimmedLinkText = options.linkText?.trim()
    const visibleLinkText = trimmedLinkText ? trimmedLinkText : url
    const text = `${visibleLinkText}: ${description}`
    return {
        text,
        kind: 'text',
        intentions: [
            {
                index: 0,
                length: visibleLinkText.length,
                kind: 'link',
                href: url,
            },
        ],
    }
}
